exports.components = {
  "component---gatsby-theme-bwsportfolio-src-pages-index-mdx": () => import("./../../../../gatsby-theme-bwsportfolio/src/pages/index.mdx" /* webpackChunkName: "component---gatsby-theme-bwsportfolio-src-pages-index-mdx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */)
}

